<div class="document-block mt-2">
    <!-- Name And Contact -->
    <div class="formSection">
        <div class="head">
            <strong>Name and Contact </strong>
        </div>

        <div class="row m-2">
            <div class="col-md-6" style="text-align: left;">
                <div><strong>Name:</strong> {{ currentFarmerData?.nameInitial?.name + ". " +
                    currentFarmerData?.firstName + " " + currentFarmerData?.lastName}}</div>
                <div><strong>Father/Husband's Name:</strong> {{ ((currentFarmerData?.relationInitial?.name)?
                    (currentFarmerData?.relationInitial?.name) : "") + " " + ((currentFarmerData?.fatherHusbandName)?
                    (currentFarmerData?.fatherHusbandName) : "")}}
                </div>
                <div><strong>Contact Number: </strong>{{ " " + currentFarmerData?.primaryPhoneNo != null ?
                    commonService.formatPhoneNumberWithHyphen(currentFarmerData?.primaryPhoneNo) : '' }}</div>
                <div><strong>Email: </strong> {{ currentFarmerData?.email || '' }}</div>
                <div><strong>Address: </strong> {{
                    ((currentFarmerData?.addresses[0]?.address1)?(currentFarmerData?.addresses[0]?.address1):'') +
                    ((currentFarmerData?.addresses[0]?.village?.name) ? ("," + " " +
                    currentFarmerData?.addresses[0]?.village?.name ) :'' )+
                    ((currentFarmerData?.addresses[0]?.village?.tehsil?.name) ? ("," + " " +
                    currentFarmerData?.addresses[0]?.village?.tehsil?.name ) :'' )+

                    ((currentFarmerData?.addresses[0]?.village?.tehsil?.district?.name)? ("," + " "
                    +currentFarmerData?.addresses[0]?.village?.tehsil?.district?.name):'') +
                    ((currentFarmerData?.addresses[0]?.village?.tehsil?.district?.state?.name) ? ("," + " " +
                    currentFarmerData?.addresses[0]?.village?.tehsil?.district?.state?.name) : '')
                    }}</div>
            </div>
            <div class="col-md-6">
                <strong>Farmer Pic : </strong><br />
                <div style="text-align: center;" class="avatar-preview">
                    <a class="lead-info">
                        <img src="{{ userProfileImage }}" width="100" height="100">
                    </a>
                </div>
                <!-- <img [src]="(currentFarmerData?.aadhaarImage)?(currentFarmerData?.aadhaarImage) : ''"  style="max-height: 120px;" /> -->
            </div>
        </div>
    </div>

    <!-- Identity -->
    <div class="formSection">
        <div class="head">
            <strong>Identity</strong>
        </div>
        <div class="row m-2">
            <div class="col-md-6" style="text-align: left;">
                <div><strong>Aadhar Number: </strong> {{
                    commonService.maskAadhaarNumber(currentFarmerData?.aadharNumber)
                    }}
                </div>
                <div><strong>PAN Number: </strong> {{ commonService.maskPanNumber(currentFarmerData?.panCardNo) || '' }}
                </div>
                <div><strong>Caste: </strong> {{ currentFarmerData?.community?.name || '' }}</div>
                <div><strong>Community: </strong> {{ currentFarmerData?.community?.religionName || '' }}</div>
            </div>
            <div class="col-md-6">
                <strong class="text-center">Bio Metric : </strong><br />
                <img [src]="currentFarmerData?.signatureImage" style="max-height: 60px;" />
            </div>
        </div>
    </div>

    <!-- Land Khata -->
    <div class="formSection" *ngIf="groupedKhasras?.length > 0">
        <div class="head">
            <strong>Land Khata Info</strong>
        </div>
        <ng-container *ngFor="let khata of groupedKhasras">
            <div class="khata-section">
                <div class="row m-2 align-items-center justify-content-between">
                    <div class="col-md-4"><strong>Khata Number: </strong> {{ khata?.landKhata?.name }}</div>
                    <div class="col-md-4"><strong>Total Khasra:</strong> {{ khata?.khasra?.length }}</div>
                    <div class="col-md-4"><strong>Total Area:</strong> {{ khata?.totalArea }} Biswa</div>
                </div>
                <table>
                    <th>Khasra #</th>
                    <th>Area (Biswa)</th>
                    <th>Payment (Farmer)</th>
                    <th>Payment (Khasra)</th>
                    <tr *ngFor="let individualKhasra of khata.khasra">
                        <td>
                            <span class="modal-hyperlink-text" (click)="openKhasraModal(individualKhasra)">
                                {{ individualKhasra?.name }}
                            </span>
                        </td>
                        <td>{{ individualKhasra?.area }}</td>
                        <td>{{commonService.formatIndianCurrency(individualKhasra?.paymentToCurrentFarmer)}}</td>
                        <td>{{commonService.formatIndianCurrency(individualKhasra?.paidAmount)}}</td>
                    </tr>
                    <tr>
                        <td class="submissionData font-weight-bolder">Total</td>
                        <td class="submissionData">{{khata?.totalArea}}</td>
                        <td class="submissionData"></td>
                        <td class="submissionData"></td>
                    </tr>
                </table>
            </div>

            <div class="formSection" *ngIf="currentFarmerData?.bankKhata?.length > 0">
                <div class="head">
                    <strong>Bank Khata Info</strong>
                </div>
            </div>
        </ng-container>
    </div>
</div>